@if (identity) {
  <div class="head">
    <mat-toolbar>
      <div class="main">
        <img class="logo" src="/assets/image/logo-xanadu-black.svg">
        <app-indexer [hidden]="hidden()" (complete)="doneSearch($event)"></app-indexer>
        <span class="spacer"></span>
        <div class="identity">
          <button mat-button class="avatar" aria-label="Example icon-button with heart icon" [matMenuTriggerFor]="menu">
            <mat-icon>account_circle</mat-icon>
            <span class="name">{{identity.name}}</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="changePassword()">Change Password</button>
            <button mat-menu-item (click)="logout()">Log Out</button>
          </mat-menu>
        </div>
      </div>
    </mat-toolbar>
  </div>
}
